import { Card, CardHeader, List } from '@mui/material';
import { Component } from 'react';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import InterventionListDetail from './InterventionListDetail';

class InterventionsAsCards extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let details = [];

        if (this.props.extranetInterventions.filteredAndSortedInterventions.length <= 0)
            return (
                <Card className="card">
                    <CardHeader title={"Aucun résultat"} className="text-center" titleTypographyProps={{ variant: "h6", color: 'primary' }} />
                </Card>
            );

        this.props.extranetInterventions.filteredAndSortedInterventions
            .filter((i) => !i.deleted)
            .forEach((i) => {
                details.push(
                    <InterventionListDetail
                        globalStore={this.props.globalStore}
                        className="intervention-list-detail"
                        key={i.name}
                        intervention={i}
                    />
                );
            });

        return <List className="row">{details.map((d) => d)}</List>;
    }
}

export default InterventionsAsCards;
